export const signatureCopy = {
  title: '',
  descriptionOff: '',
  descriptionOn: '',
  label: '',
};
